export enum BreakpointEnum {
  XS = 320,
  SM = 640,
  MD = 768,
  LG = 1024,
  XL = 1280,
  XXL= 1536,
}